import { QuickAddScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <QuickAddScreen />;
}
